<template>
  <div
    :class="inputVal ? 'active' : ''"
    @mouseenter="btn = true"
    @mouseleave="btn = false"
    style="width: 100%; height: 100% ;"
  >
    <div id="kmtemplate" @click.stop="enterDel" v-popover:popover1>
      <div v-show="!inputVal" class="titleKm">
        <p class="km" v-show="!showMsg">{{ kmName }}</p>
        <el-input
          v-show="showMsg"
          v-model="kmName"
          class="tipsInput"
          ref="moneyRef"
          @keydown.native="changesMoney"
          :readonly="true"
        ></el-input>
        <p v-show="yeMoney && yeMoney != 0">
          余额:<span :class="yeMoney < 0 ? 'red' : ''">{{ yeMoney }}</span>
        </p>
      </div>
      <!-- remote :remote-method="remoteMethod" @focus.stop="filterSelfs('')"-->
      <el-select
        v-show="inputVal"
        v-model="selectData"
        popper-class="options"
        placeholder="请选择科目"
        ref="selectRef"
        filterable
        :default-first-option="true"
        :filter-method="filterSelfs"
        @blur.stop="inputBlur"
        @change="selectChange($event, '')"
        @visible-change="closeSelect"
        @keydown.enter.native="enterSelect"
        @keydown.tab.native.prevent="tabChanges"
      >
        <el-option
          v-for="(item, index) in subjectList1"
          :key="index"
          v-if="index < 30"
          :value="item.code + ' ' + item.name"
          :label="item.code + ' ' + item.name"
        ></el-option>
        <template>
          <div class="addKM" @click.stop="newModalOpen">+新增科目</div>
        </template>
      </el-select>
    </div>
    <!-- 弹窗框 -->
    <!-- 科目弹出层-->
    <subject-dialog
      :subParent="false"
      v-if="dialog"
      :show="dialog"
      :subjectData="formDatas"
      @on-close-modal="cancel"
      @add-success-subject="addSuccessCallback"
    ></subject-dialog>
    <!-- 辅助核算 -->
    <el-popover
      ref="popover1"
      v-model="visible"
      trigger="manual"
      placement="bottom-start"
    >
      <el-form
        label-width="70px"
        ref="modalRefsForm"
        :model="listLabel.auxlaryObj"
        @keyup.enter.native="getSaveauxil('modalRefsForm')"
      >
        <el-form-item
          v-for="(item, index) in listLabel.auxlaryObj.auxiliarys"
          :key="index"
          :label="item.name + ':'"
          :rules="{
            required: true,
            message: item.name + '不能为空',
            trigger: 'blur',
          }"
          :prop="'auxiliarys.' + index + '.value'"
        >
          <el-select
            ref="selected"
            size="mini"
            filterable
            v-model="item.value"
            clearable
            style="width: 200px"
            :default-first-option="true"
            @keyup.enter.native.prevent="
              enterModalFocus(
                index,
                item.value,
                'modalRefsForm',
                listLabel.auxlaryObj.auxiliarys.length
              )
            "
          >
            <el-option
              v-for="(items, index) in item.auxiliaryAccContentVos"
              :key="index"
              :label="items.code + ' ' + items.name"
              :value="items.id"
            ></el-option>
          </el-select>
          <el-button type="text" size="mini" @click="addAssiAcount(item)"
            >新增</el-button
          >
        </el-form-item>
        <el-button
          class="fr minButton"
          size="small"
          @click="getSaveauxil('modalRefsForm')"
          >保存</el-button
        >
      </el-form>
    </el-popover>

    <!-- 弹窗框 -->
    <el-dialog
      title="新增辅助核算"
      append-to-body
      :visible.sync="addkm.modal1"
      width="420px"
      :close-on-click-modal="false"
      @keyup.enter.native="addAuxilAccount('diaFormData')"
      class="handleDialogS"
    >
      <div
        class="form-item-public"
        v-loading="addkm.loading1"
        v-if="addkm.modal1"
      >
        <el-form
          label-width="70px"
          :model="diaFormData"
          ref="diaFormData"
          :rules="diaFormDataRuler"
        >
          <el-form-item label="编码:" required prop="code">
            <el-input
              v-model="diaFormData.code"
              size="small"
              placeholder="请输入编码!"
            ></el-input>
          </el-form-item>
          <el-form-item label="名称:" required prop="name">
            <el-input
              v-model="diaFormData.name"
              size="small"
              placeholder="请输入名称!"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="规格:"
            prop="specifications"
            v-show="tabValName == '存货'"
          >
            <el-input
              v-model="diaFormData.specifications"
              size="small"
              placeholder="请输入核算规格!"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位:" prop="unit" v-show="tabValName == '存货'">
            <el-input
              v-model="diaFormData.unit"
              size="small"
              placeholder="请输入类别单位!"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer-right" v-show="!addkm.loading1">
        <el-button size="small" @click="addkm.modal1 = false">取消</el-button>
        <el-button
          size="small"
          class="minButton"
          @click="addAuxilAccount('diaFormData')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import subjectDialog from "@/components/dialog/subjectDialog";
export default {
  props: ["kmText", "inputFocus", "kmlist", "XG_voucherShows"],
  data() {
    const gg = (rule, value, callback) => {
      if (this.tabValName == "存货") {
        if (value == "") {
          callback(new Error("规格必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const sl = (rule, value, callback) => {
      if (this.tabValName == "存货") {
        if (value == "") {
          callback(new Error("数量必填!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      dialog: false, ///科目弹出层
      formDatas: {
        methods: "add",
        type: "资产",
        creditDirection: "借",
      },
      visible: false,
      loading: false,
      btn: false,
      inputVal: false,
      showMsg: false,
      selectData: "",
      addkm: {
        modal: false,
        loading: false,

        modal1: false,
        loading1: false,
      },
      listLabel: {
        auxlist: [],
        auxlaryObj: {},
      },
      propskm: { code: "", name: "", nums: 0, subjectNames: "" }, ///保存的科目对象内容
      codes: "",

      tabValName: "",
      tabVal: "",
      diaFormData: {
        code: "",
        name: "",
        specifications: "",
        unit: "",
      },
      diaFormDataRuler: {
        code: [{ required: true, message: "编码必填!" }],
        name: [{ required: true, message: "名字必填!" }],
        specifications: [{ validator: gg, trigger: "blur" }],
        unit: [{ validator: sl, trigger: "blur" }],
      },
      subjectList: [],
      subjectList1: [],

      kmNames: "",
      change: false,
      onlyChangeAuxlars: false,

      ifAddsubject: false, //是否新增了科目
    };
  },
  computed: {
    kmName: {
      get: function () {
        let name = "";
        if (!this.change) {
          name = this.kmNames;
        } else {
          if (this.propskm.code != "" && this.propskm.name != "") {
            name = this.propskm.code + " " + this.propskm.name + this.codes;
          } else {
            name = "";
          }
        }
        return name;
      },
    },
    yeMoney: {
      get: function () {
        var bol = this.$store.state.loadstatus.voucherEdit;
        var bols = this.$store.state.loadstatus.ifEditVoucer;
        if (!bols) {
          this.change = false;
        }
        var km = this.kmText;
        var num = 0;
        if (this.kmText.fkSubjectId != "") {
          if (bol && !this.change) {
            num = km.remainingSum;
          } else if (bol && this.onlyChangeAuxlars) {
            //如果只是修改辅助核算 金额也不发生变化
            num = km.remainingSum;
          } else {
            num = km.subjectVo.nums;
          }
        }
        return num;
      },
    },
  },
  components: {
    subjectDialog,
  },
  created() {
    this.init();
  },
  methods: {
    init() {}, //查询所有辅助核算科目
    getSujectAuxiliaryByType() {
      const _ = this;
      if (_.subjectList.length <= 0 || _.subjectList == "") {
        _.$store.dispatch("getSujectAuxiliaryByType", {});
      }
    },
    cancel() {
      this.dialog = false;
      //刷新科目列表数据
      // this.$store.dispatch("getSujectAuxiliaryByType", {});
      this.$emit("on_success_info", true);
    },
    //新增成功科目后进行新的赋值
    addSuccessCallback(val) {
      const _ = this;
      _.ifAddsubject = true;
      _.propskm = {
        code: val.newCode || (val.code + val.selfCode),
        name: val.oldSubname + "_" + val.subname,
        nums: 0,
        subjectNames: "",
      };
      //刷新科目列表数据
      _.$emit("on_success_info", true);
    },
    enterDel() {
      let auxli = this.$store.state.loadstatus.auxliaryModal;
      if (auxli && !this.visible) {
        this.$message.error("请选择辅助核算！");
        return false;
      }

      //当已选择辅助核算时 则进行修改辅助核算
      if (
        this.propskm.auxiliaryAccountingIds &&
        this.propskm.auxiliaryAccountingIds != ""
      ) {
        let ids = this.propskm.auxiliaryAccountingIds.split(",");
        let len = this.listLabel.auxlaryObj.auxiliarys;
        for (let i = 0; i < len.length; i++) {
          this.$set(len[i], "value", ids[i]);
        }
        this.visible = true;
        this.showMsg = true;
        this.$nextTick(() => {
          this.$refs.moneyRef.select();
        });
      } else {
        if (this.propskm.code != "") {
          this.selectChange(this.propskm.code, "keys");
        } else {
          this.showMsg = true;
          this.inputVal = true;
          this.$nextTick(() => {
            this.$refs.selectRef.focus();
          });
        }
      }
    },
    inputBlur() {
      this.inputVal = false;
      if (this.selectData == "" || this.selectData == null) {
        this.propskm = { name: "", code: "", nums: 0 };
        this.codes = "";
        this.subjectList1 = JSON.parse(JSON.stringify(this.subjectList));
      }
    },
    selectChange(index, key) {
      const _ = this;
      _.change = true;
      _.onlyChangeAuxlars = false; //仅仅修改了辅助核算
      _.$store.commit("UPDATAVOUCHER", true);
      _.$store.commit("UPDATAVOUCHER_SUPER", false);
      _.codes = "";
      if (index != "" || index != null) {
        let val = _.subjectList.find((item) => {
          let codes = index.split(" ")[0];
          if (item.code == codes) {
            return item;
          }
        });
        // console.log("当前选中的科目=================》",val);
        _.selectData = val.code + " " + val.name;
        val.change = true;
        _.propskm = val;
        _.addAuxlist(val, "", function (msg) {
          if (msg.auxiliarys.length > 0) {
            _.visible = true;
            _.$nextTick(() => {
              _.$refs["selected"][0].focus();
            });
          } else {
            _.visible = false;
            if (key == "") {
              _.$emit("on-enter-keyDown", true);
            }
            if (key != "none") {
              //如果没有辅助核算则打开下拉
              if (_.selectData != "" && key != "") {
                _.showMsg = true;
                _.inputVal = true;
                _.$nextTick(() => {
                  _.$refs.selectRef.focus();
                });
              }
            }
          }
        });
      } else {
        _.propskm = { name: "", code: "", nums: 0 };
      }
      _.visible = false;
      if (key == "") {
        _.inputVal = false;
      }
      _.propskm.auxiliaryAccountingIds = "";
      let values = { ..._.propskm, select: key?false:true }
      _.$emit("on-push-objects", values);
      this.showMsg = false;
    }, //打开新增科目弹框
    newModalOpen() {
      const _ = this;
      _.dialog = true;
      _.$refs.selectRef.blur();
      _.formDatas = {
        methods: "add",
        type: "资产",
        creditDirection: "借",
      };
    }, //查询辅助核算
    addAuxlist(row, val, callback) {
      const _ = this;
      if (row.id && row.id != "") {
        _.loading = true;
        _.$http
          .post("auxiliaryAccounting/getAuxiliaryBySubjectId", {
            subjectId: row.id,
          })
          .then((res) => {
            _.loading = false;
            if (res && res.data.code == "1") {
              let list = res.data.data;
              for (let i = 0; i < list.auxiliarys.length; i++) {
                list.auxiliarys[i].value = "";
              }
              _.listLabel.auxlaryObj = list;
              /* //赋值辅助核算
							if(val.auxiliaryAccountingIds){
								let newArr =  new Array();
								let ids = val.auxiliaryAccountingIds.split(',');
								for(let i=0;i<list.auxiliarys.length;i++){
									for(let k=0;k<list.auxiliarys[i].auxiliaryAccContentVos.length;k++){
										newArr.push(list.auxiliarys[i].auxiliaryAccContentVos[k])
									}
								};
								var code ='';
								for(let j=0;j<newArr.length;j++){
									for(let m=0;m<ids.length;m++){
										if(newArr[j].id == ids[m]){
											code+='_'+newArr[j].name;
										}
									}
								};
								_.codes = code;
							}; */
              callback(list);
            }
          })
          .catch(() => {
            _.loading = false;
          });
      }
    }, //保存辅助核算
    getSaveauxil(ref) {
      const _ = this;
      _.$refs[ref].validate((valid) => {
        if (valid) {
          let list = _.listLabel.auxlaryObj.auxiliarys;
          let ids = "";
          let codes = "";
          for (let i = 0; i < list.length; i++) {
            ids += list[i].value + ",";
            for (let k = 0; k < list[i].auxiliaryAccContentVos.length; k++) {
              if (list[i].value == list[i].auxiliaryAccContentVos[k].id) {
                codes += "_" + list[i].auxiliaryAccContentVos[k].name;
              }
            }
            ///保存后关闭下拉框内容
            _.$nextTick(() => {
              _.$refs["selected"][i].handleClose();
            });
          }

          _.change = true;
          _.onlyChangeAuxlars = true; //仅仅修改了辅助核算
          _.$store.commit("UPDATAVOUCHER", true);

          _.codes = codes;
          _.propskm.subjectNames = this.kmName;
          _.propskm.auxiliaryAccountingIds = ids;
          _.$emit("on-push-objects", _.propskm);
          _.visible = false;
          _.inputVal = false;
          _.$emit("on-enter-keyDown", true);
        }
      });
    },
    addAssiAcount(row) {
      const _ = this;
      _.tabValName = row.name;
      _.tabVal = row.id;
      _.addkm.modal1 = true;
      _.diaFormData = _.$resert(_.diaFormData);
    }, //新增辅助核算
    addAuxilAccount(ref) {
      const _ = this;
      _.$refs[ref].validate((valid) => {
        if (valid) {
          _.addkm.loading = true;
          _.diaFormData.auxiliaryAccountingId = _.tabVal;
          _.$http
            .post("auxiliaryAccounting/addContent", _.diaFormData)
            .then((res) => {
              _.addkm.loading = false;
              if (res && res.data.code == "1") {
                _.$message({
                  message: res.data.msg,
                  type: "success",
                });
                _.addkm.modal1 = false;
                _.addAuxlist(_.propskm);
              }
            })
            .catch((e) => {
              _.addkm.loading = false;
            });
        }
      });
    },
    enterSelect() {
      const _ = this;
      if (_.selectData == "" || _.selectData == null) {
        _.selectChange(_.subjectList1[0].code, "");
      } else {
        _.$emit("on-enter-keyDown", true);
      }
      _.$refs.selectRef.blur();
      _.inputVal = false;
    },
    closeSelect(val) {
      const _ = this;
      if (!val) {
        _.inputVal = false;
      } else {
        //刷新科目列表数据
        //this.$store.dispatch('getSujectAuxiliaryByType',{});
      }
    }, ///enetet 事件
    enterModalFocus(ins, val, form, len) {
      const _ = this;
      if (ins + 1 < len) {
        _.$nextTick(() => {
          if (val != "") {
            _.$refs["selected"][ins + 1].focus();
          }
        });
      } else {
        _.getSaveauxil(form);
      }
    }, //tab事件控制
    tabChanges(val) {
      const _ = this;
      _.inputVal = false;
      if (val.shiftKey) {
        _.$emit("on-tab-focusChange", false);
      } else {
        _.$emit("on-tab-focusChange", true);
      }
    },
    closeAuxliary() {
      this.visible = false;
    }, //自定义搜索
    filterSelfs(val) {
      const _ = this;
      _.closeAuxliary();
      if (val != "" && val != null && val != " ") {
        _.selectData = val;

        _.subjectList1 = _.subjectList.filter((item) => {
          if (item.code.indexOf(val) == 0) {
            return true;
          } else if (item.name.indexOf(val) != -1) {
            return true;
          }
        });
      } else {
        _.subjectList1 = JSON.parse(JSON.stringify(_.subjectList));
        _.selectData = "";
        _.visible = false;
        //_.propskm = {name:'',code:'',nums:0};
        _.propskm.auxiliaryAccountingIds = "";
        _.$emit("on-push-objects", _.propskm);
      }
    },
    changesMoney() {
      const _ = this;
      _.propskm = { name: "", code: "", nums: 0 };
      _.visible = false;
      _.inputVal = true;
      _.selectData = "";
      _.visible = false;
      _.propskm.auxiliaryAccountingIds = "";
      _.$emit("on-push-objects", _.propskm);
      _.$nextTick(() => {
        _.$refs.selectRef.focus();
      });
    },
  },
  mounted() {
    //this.propskm = this.kmText.subjectVo;
    //this.selectData = this.kmText.subjectVo.name ? this.kmText.subjectVo.name : '';
  },
  activated() {
    this.addAuxlist(this.kmText.subjectVo, this.kmText);
    // this.$store.dispatch("getSujectAuxiliaryByType", {});
  },
  deactivated() {
    this.visible = false;
  },
  watch: {
    kmText: {
      handler(val) {
        const _ = this;
        if (val.subjectVo.name != "") {
          _.kmNames = val.subjectName
            ? val.subjectName
            : val.subjectVo.code + " " + val.subjectVo.name;
        } else {
          _.kmNames = "";
        }
        _.propskm = val.subjectVo;
        if (val.auxiliaryAccountingIds != "") {
          this.addAuxlist(val.subjectVo, val);
        }
        _.selectData = val.subjectVo.name
          ? val.subjectVo.code + " " + val.subjectVo.name
          : "";
        let auxli = this.$store.state.loadstatus.auxliaryModal;
        if (!auxli) {
          _.visible = false;
        }
      },
      deep: true,
      immediate: true,
    },
    kmlist: {
      handler(val) {
        const _ = this;
        _.subjectList = val;
        if (_.ifAddsubject) {
          _.subjectList1 = JSON.parse(JSON.stringify(val));
          _.ifAddsubject = false;
          _.selectChange(_.propskm.code, "none");
        }
      },
      deep: true,
      immediate: true,
    },
    propskm: {
      handler(Val) {
        this.$emit("on-push-objects", Val);
      },
      deep: true,
    },
    inputFocus: {
      handler(Val) {
        const _ = this;
        if (Val && Val.subInputFocus) {
          _.inputVal = true;
          _.$nextTick(() => {
            _.$refs.selectRef.focus();
          });
        }
      },
      deep: true,
    },
    XG_voucherShows(val) {
      if (!val) {
        this.visible = false;
      }
    },
    visible(val) {
      this.$store.commit("UPDATEAUXLIARY", val);
      this.$emit("on-mask-visible", val);
    },
    inputVal(val, ov) {
      if (val && this.subjectList1.length <= 0) {
        this.subjectList1 = JSON.parse(JSON.stringify(this.kmlist));
      }
    },
    kmName(val, ov) {
      if (val == "") {
        this.subjectList1 = JSON.parse(JSON.stringify(this.subjectList));
      }
    },
  },
};
</script>

<style lang="less">
.active {
  background-color: #fff;
}
#kmtemplate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 56px;
  padding: 0 5px;
  padding-right: 71px;
  cursor: pointer;
  .el-input,
  .el-select {
    height: 100%;
    width: 100%;
    font-size: 14px;
    padding-right: 15px;
    line-height: 100%;
    .el-input__inner {
      border: none;
      padding-left: 0;
      height: 100%;
      line-height: 100%;
      &:focus {
        border: none;
      }
    }
  }
  .titleKm {
    width: 100%;
    text-align: left;
    font-size: 14px;
    .tipsInput {
      height: 30px;
      line-height: 30px;
      .el-input__inner {
        height: 30px;
        line-height: 30px;
        padding-left: 0;
        background: none !important;
      }
    }
    .km {
      line-height: 20px;
    }
    span.red {
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/kmTemplate.vue